module.exports = __webpack_public_path__ + "assets/img/Twitter.613cd150.svg";